/* eslint-disable react/function-component-definition,jsx-a11y/control-has-associated-label */
import clsx from 'clsx'
import React, { useMemo } from 'react'
import './Table.module.scss'

// One tri-state icon instead of two arrows keeps sortable headers narrow.
const SORT_ICONS = {
  asc: 'fa-sort-up Uic-Table-sortHighlighted',
  desc: 'fa-sort-down Uic-Table-sortHighlighted',
}

const sortCaret = (loading) => (order) => (
  <button type="button" className="Uic-Table-sortCaret" disabled={loading}>
    <span className={clsx('fa', SORT_ICONS[order] || 'fa-sort')} />
  </button>
)

const useSort = ({ loading }) => {
  const sort = useMemo(
    () => ({
      sortCaret: sortCaret(loading),
    }),
    [loading],
  )

  return sort
}

export default useSort
